module.exports = __webpack_public_path__ + "static/media/checkboxInstall1.84baa13b.svg";